/* eslint-disable */
import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Flex,
  useDisclosure,
  useToast,
  IconButton,
  Tooltip,
  Badge,
} from "@chakra-ui/react";

import { ViewIcon, RepeatIcon, EditIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";

import axiosClient from "../../../api/axiosClient";
import CategoryDetailDialog from "./components/CategoryDetailDialog";
import ReassignDepartemenDialog from "./components/ReassignDepartemenDialog";
import ReassignUserDialog from "./components/ReassignUserDialog";

export default function DynamicTable({ columnsData, endpoint }) {
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});
  const [page, setPage] = useState(1);

  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedDepartemenId, setSelectedDepartemenId] = useState(null);
  const [isUserDialogOpen, setIsUserDialogOpen] = useState(false);

  const toast = useToast();
  const navigate = useNavigate();

  const {
    isOpen: isDetailOpen,
    onOpen: onDetailOpen,
    onClose: onDetailClose,
  } = useDisclosure();

  const {
    isOpen: isReassignOpen,
    onOpen: onReassignOpen,
    onClose: onReassignClose,
  } = useDisclosure();

  const loadData = async () => {
    try {
      const res = await axiosClient.get(`${endpoint}?page=${page}`);
      setData(res.data.data || []);
      setMeta(res.data.meta || {});
    } catch (error) {
      toast({
        title: "Gagal memuat data",
        status: "error",
      });
    }
  };

  useEffect(() => {
    loadData();
  }, [page]);

  const handleFollowUp = async (ticketId) => {
    try {
      await axiosClient.put(`tickets/updateStatusProgress/${ticketId}`);

      toast({
        title: "Status berhasil diupdate ke Progress",
        status: "success",
      });

      navigate(`/admin/form-penyelesaian/${ticketId}`);
    } catch (error) {
      toast({
        title: "Gagal update status",
        status: "error",
      });
    }
  };

  const getApprovalStatus = (row) => {
    return (
      row?.reassign_approval_status ||
      row?.approval_status ||
      row?.pengalihan_status ||
      null
    );
  };

  const renderApprovalBadge = (row) => {
    const status = getApprovalStatus(row);

    if (!status) return null;

    const color =
      status === "approved"
        ? "green"
        : status === "rejected"
        ? "red"
        : "orange";

    const label =
      status === "approved"
        ? "Disetujui"
        : status === "rejected"
        ? "Ditolak"
        : "Menunggu Approval";

    return (
      <Badge colorScheme={color} variant="subtle" borderRadius="8px">
        {label}
      </Badge>
    );
  };

  return (
    <Box w="100%">
      <Table variant="simple">
        <Thead>
          <Tr>
            {columnsData.map((col, i) => (
              <Th key={i}>{col.Header}</Th>
            ))}
            <Th>Status Approval</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>

        <Tbody>
          {data.map((row, i) => (
            <Tr key={row.id || i}>
              {columnsData.map((col, j) => (
                <Td key={j}>
                  {col.accessor === "__index"
                    ? (page - 1) * (meta?.per_page ?? data.length) + i + 1
                    : col.Cell
                    ? col.Cell(row[col.accessor], row)
                    : row[col.accessor]}
                </Td>
              ))}

              <Td>{renderApprovalBadge(row) || "-"}</Td>

              <Td>
                <Flex gap="10px">
                  <Tooltip label="Detail" hasArrow>
                    <IconButton
                      icon={<ViewIcon />}
                      size="sm"
                      colorScheme="blue"
                      aria-label="Detail"
                      onClick={() => {
                        setSelectedRow(row);
                        onDetailOpen();
                      }}
                    />
                  </Tooltip>

                  <Tooltip label="Ajukan Pengalihan" hasArrow>
                    <IconButton
                      icon={<RepeatIcon />}
                      size="sm"
                      colorScheme="orange"
                      aria-label="Dialihkan"
                      isDisabled={getApprovalStatus(row) === "pending"}
                      onClick={() => {
                        setSelectedRow(row);
                        onReassignOpen();
                      }}
                    />
                  </Tooltip>

                  <Tooltip label="Tindak Lanjut" hasArrow>
                    <IconButton
                      icon={<EditIcon />}
                      size="sm"
                      colorScheme="green"
                      aria-label="Tindak Lanjut"
                      onClick={() => handleFollowUp(row.id)}
                    />
                  </Tooltip>
                </Flex>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Flex mt="20px" justifyContent="center" alignItems="center" gap="10px">
        <Button
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          isDisabled={page === 1}
        >
          Prev
        </Button>

        <Box mt="8px">
          Page {page} / {meta?.total_pages ?? 1}
        </Box>

        <Button
          onClick={() => setPage((p) => p + 1)}
          isDisabled={page >= (meta?.total_pages ?? 1)}
        >
          Next
        </Button>
      </Flex>

      <CategoryDetailDialog
        isOpen={isDetailOpen}
        onClose={onDetailClose}
        data={selectedRow}
      />

      <ReassignDepartemenDialog
        isOpen={isReassignOpen}
        onClose={onReassignClose}
        data={selectedRow}
        onDepartemenSelect={(departemenId) => {
          setSelectedDepartemenId(departemenId);
          setIsUserDialogOpen(true);
        }}
      />

      <ReassignUserDialog
        isOpen={isUserDialogOpen}
        onClose={() => setIsUserDialogOpen(false)}
        departemenId={selectedDepartemenId}
        ticketId={selectedRow?.id}
        onSuccess={loadData}
      />
    </Box>
  );
}